import { render, staticRenderFns } from "./sso-configuration-card.vue?vue&type=template&id=c423fc54&scoped=true"
import script from "./sso-configuration-card.vue?vue&type=script&lang=js"
export * from "./sso-configuration-card.vue?vue&type=script&lang=js"
import style0 from "./sso-configuration-card.vue?vue&type=style&index=0&id=c423fc54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c423fc54",
  null
  
)

export default component.exports